// test1712
(1712 && 0);
